import React from "react";
import Card from "react-bootstrap/Card";
import { Row, Col } from "react-bootstrap";
import { ImPointRight } from "react-icons/im";
import { FaGraduationCap, FaHeart, FaLightbulb } from "react-icons/fa";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          {/* Professional Introduction */}
          <div style={{ marginBottom: "30px" }}>
            <p style={{ textAlign: "justify", fontSize: "1.1em", lineHeight: "1.6" }}>
              Bonjour ! Je suis <span className="purple">Maëlle Barrois-Legrand</span>,
              <span className="purple"> designer d'espace et scénographe</span>, animée par une passion profonde pour la création et la conception d'environnements uniques.
              <br /><br />
              Diplômée d'un master en architecture d'intérieur, j'ai à cœur de créer des <strong>espaces qui vous ressemblent</strong>.
              Chacun de vos projets sera vu comme un nouveau défi et une opportunité d'explorer de nouvelles idées pour exprimer ma créativité.
            </p>
          </div>

          {/* Education & Experience */}
          <Row style={{ marginBottom: "30px" }}>
            <Col md={12}>
              <h5 style={{ color: "var(--medium-brown)", marginBottom: "15px" }}>
                <FaGraduationCap style={{ marginRight: "10px" }} />
                Formations & Parcours
              </h5>
              <ul style={{ listStyle: "none", paddingLeft: "0" }}>
                <li style={{ marginBottom: "8px" }}>
                  <ImPointRight style={{ color: "var(--medium-brown)", marginRight: "10px" }} />
                  <strong>Ouverture d'auto-entreprise</strong> - 2025
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <ImPointRight style={{ color: "var(--medium-brown)", marginRight: "10px" }} />
                  <strong>Master Architecture d'Intérieur</strong> - 2024
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <ImPointRight style={{ color: "var(--medium-brown)", marginRight: "10px" }} />
                  <strong>Bachelor Design d'Espace</strong> - 2022
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <ImPointRight style={{ color: "var(--medium-brown)", marginRight: "10px" }} />
                  <strong>Alternance en architecture d'intérieur</strong> - 2021-2024
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <ImPointRight style={{ color: "var(--medium-brown)", marginRight: "10px" }} />
                  <strong>Stage en architecture</strong> - 2021
                </li>
              </ul>
            </Col>
          </Row>

          {/* Passions & Interests */}
          <Row style={{ marginBottom: "25px" }}>
            <Col md={12}>
              <h5 style={{ color: "var(--medium-brown)", marginBottom: "15px" }}>
                <FaHeart style={{ marginRight: "10px" }} />
                Passions
              </h5>
              <ul style={{ listStyle: "none", paddingLeft: "0" }}>
                <li className="about-activity">
                  <ImPointRight /> Dessin numérique & Photographie
                </li>
                <li className="about-activity">
                  <ImPointRight /> Travaux manuels & Bricolage
                </li>
                <li className="about-activity">
                  <ImPointRight /> Sport de tir de précision
                </li>
              </ul>
            </Col>
          </Row>

          {/* Philosophy */}
          <div style={{
            backgroundColor: "rgba(139, 115, 85, 0.1)",
            padding: "20px",
            borderRadius: "10px",
            borderLeft: "4px solid var(--medium-brown)",
            marginBottom: "20px"
          }}>
            <h5 style={{ color: "var(--medium-brown)", marginBottom: "15px" }}>
              <FaLightbulb style={{ marginRight: "10px" }} />
              Ma Philosophie
            </h5>
            <p style={{
              fontStyle: "italic",
              fontSize: "1.1em",
              color: "var(--primary-text)",
              marginBottom: "10px",
              textAlign: "center"
            }}>
              "Vous voyez des choses et vous vous dites : 'pourquoi ?' Mais moi je rêve de choses qui n'ont jamais existé et je me dis : 'pourquoi pas ?'"
            </p>
            <p style={{
              fontSize: "0.9em",
              color: "var(--secondary-text)",
              marginBottom: "0",
              textAlign: "right",
              fontStyle: "normal"
            }}>
              - George Bernard Shaw
            </p>
          </div>

          <footer className="blockquote-footer" style={{ textAlign: "center", fontSize: "1.1em" }}>
            MBL Designer
          </footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
